// @flow
import React from 'react';

import { withHelmet } from 'infrastructure/seo/Helmet';
import SubMenuHeaderContainer from 'containers/header/SubMenuHeaderContainer';
import Breadcrumb from 'components/fragments/Breadcrumb';
import BackgroundImage from 'components/fragments/BackgroundImage';

import type { SourceSetType } from 'types/Article';

export type StateProps = {
  title: string,
  slug_parent: string,
  slug: string,
  titleParent: string,
  description: string,
  featured_media: {
    src: string,
    legend: string,
    size: SourceSetType
  },
  templateDetail: string,
  meta_description: string,
  meta_title: string
};

type Props = {
  title: string,
  withSubMenu: boolean,
  className?: string,
  parentSlug?: string,
  parentName?: string,
} & StateProps;

const PageNodeHeader = (props: Props) => {
  const {
    className,
    featured_media,
    titleParent,
    slug_parent,
    parentSlug,
    parentName,
    title,
    description,
    withSubMenu,
    slug,
    templateDetail,
  } = props;

  let classTemplate = false;

  if (templateDetail === 'page-academies_rugby' || templateDetail === 'page-academies_poles_espoirs') {
    classTemplate = 'banner--map';
  }
  const parent = {
    name: parentName ? parentName : titleParent,
    to: `/${parentSlug ? parentSlug : slug_parent}`,
  };
  return (
    <section className={`banner ${className ? className: ''} ${classTemplate ? classTemplate: ''}`}>
      {featured_media.src !== '' ? (
        <BackgroundImage
          className="banner__thumbnail img-green"
          illustration={featured_media.src}
          srcset={featured_media.size}
          baliseImg={false}
        />
      ) : (
        <div className="banner__thumbnail img-green" />
      )}
      <div className="container">
        <Breadcrumb
          elements={[
            { name: 'accueil', to: '/' },
            parent,
            title
          ]}
          isDark
        />

        <h1 className="ft-h2">{title}</h1>
        <p className="banner__desc">{description}</p>
      </div>
      {withSubMenu && <SubMenuHeaderContainer subMenuPath={`/${slug_parent}/${slug}`} />}
    </section>
  );
};

export default withHelmet(PageNodeHeader)((Helmet, pageProps) => {
  const ogimage = pageProps.featured_media.src;
  const ogimagetitle = pageProps.featured_media.title;
  return (
    <Helmet>
      <title>{pageProps.meta_title}</title>
      <meta name={'description'} content={`${pageProps.meta_description.slice(0, 197)}...`} />
      <meta property={'og:url'} content={window.location.href} />
      <meta property={'og:title'} content={pageProps.meta_title} />
      <meta property={'og:description'} content={`${pageProps.meta_description.slice(0, 197)}...`} />
      {ogimage && <meta property={'og:image'} content={ogimage} />}
      {ogimage && <meta property={'og:image:url'} content={ogimage} />}
      {(ogimage && ogimagetitle) && <meta property={'og:image:title'} content={ogimagetitle} />}
      <link rel={'canonical'} href={window.location.href} />
    </Helmet>
  );
});
